import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetCoordinatesFromAddressUseCaseInterface } from 'domain/usecases';

import { HttpStatusCode } from '../../protocols/http';

export class RemoteGetCoordinatesFromAddress
  implements GetCoordinatesFromAddressUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient,
  ) {}

  async execute(
    params: GetCoordinatesFromAddressUseCaseInterface.Params,
  ): Promise<GetCoordinatesFromAddressUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      url: generateUrl(this.url, params),
      method: 'get',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  }
}
